import {
    apiRequest,
    polaKerjaCreate,
    flexytimeList,
    presensiLocationList
} from "../../../../../services/adapters/kepegawaian/polaKerjaService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", polaKerjaCreate, {
            body: query
        }, true)
    }

    fetchFlexytime = async (query) => {
        return await apiRequest("get", flexytimeList, {
            params: query
        }, true)
    }

    fetchLocation = async (query) => {
        return await apiRequest("get", presensiLocationList, {
            params: query
        }, true)
    }
}

export default CreateRepository